import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import React, { FC } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { Loader } from 'src/common'
import { useProfileFactoryStyles } from './profile-factory.styles'
import {
  ProfileFactoryLocation,
  ProfileFactorySocial,
  useQueryMyProfileFactory,
  useMutationDeactiveProfileFactory,
  useMutationActiveProfileFactory,
  ProfileFactoryNotFound,
  ProfileFactoryLegal,
  ProfileFactorySpecialization,
  ProfileFactoryStructure
} from '../common'
import { TranslationDictionary } from '@plandi/common'

interface IProfileFactoryProps {
  translate?: TranslationDictionary['data']
  locale: string
}

export const ProfileFactory: FC<IProfileFactoryProps> = ({
  locale,
  translate
}) => {
  const classes = useProfileFactoryStyles()
  const router = useRouter()

  const { data: profile, isLoading } = useQueryMyProfileFactory()
  const mutationDeactiveProfile = useMutationDeactiveProfileFactory()
  const mutationActiveProfile = useMutationActiveProfileFactory()

  const handleDeactiveProfile = () => {
    if (profile?.id) {
      mutationDeactiveProfile.mutate(profile.id)
    }
  }

  const handleActiveProfile = () => {
    if (profile?.id) {
      mutationActiveProfile.mutate(profile.id)
    }
  }

  if (isLoading) {
    return <Loader />
  }

  if (!profile) {
    return <ProfileFactoryNotFound translate={translate} locale={locale} />
  }

  return (
    <>
      <div className={classes.message}>
        <div className={classes.messageInfo}>
          <Typography variant="h5">
            {translate?.['job-site']?.profile?.['required-information'] ??
              'Пожалуйста, заполните необходимую информацию.'}
          </Typography>
          <Typography variant="body2">
            {translate?.['job-site']?.profile?.['sub-required-info'] ??
              'Она обязательна для более высокого рейтинга вашей анкеты.'}
          </Typography>
          <Typography variant="body2" className={classes.messageRequared}>
            {translate?.['job-site']?.['fields-with-required'] ??
              'Поля с * являются обязательными для заполнения'}
          </Typography>
        </div>
        <div className={classes.portfolioButton}>
          <Link
            href={{
              pathname: '/profile-factory/[slugName]/[profileId]/portfolio',
              query: {
                profileId: profile?.id,
                slugName:
                  profile?.slug_name || router.query.slugName || 'no-slug-name'
              }
            }}
            passHref
          >
            <Button variant="contained" color="primary" fullWidth>
              {translate?.['job-site']?.portfolio ?? 'Портфолио'}
            </Button>
          </Link>
        </div>
      </div>
      <ProfileFactoryLegal translate={translate} locale={locale} />
      <ProfileFactorySpecialization translate={translate} locale={locale} />
      <ProfileFactoryStructure translate={translate} locale={locale} />
      <ProfileFactoryLocation translate={translate} />
      <ProfileFactorySocial translate={translate} />
      <div className={classes.action}>
        {profile.isActive ? (
          <Button
            variant="contained"
            color="primary"
            className={classes.deactiveProfileButton}
            onClick={handleDeactiveProfile}
          >
            {translate?.['job-site']?.profile?.['deactivate-btn'] ??
              'Деактивировать анкету'}
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            className={classes.deactiveProfileButton}
            onClick={handleActiveProfile}
            disabled={profile.isBlocked}
          >
            {translate?.['job-site']?.['activate-profile'] ??
              'Активировать анкету'}
          </Button>
        )}
      </div>
    </>
  )
}
